export default function roomEventListener(room) {
  return store => {
    room.addEventListeners({
        room_doc_add: e => {
            store.commit('doc/addRoomDocFile', e.data)
        },
        room_doc_startConvert: e => {

        },
        room_doc_remove: e => {
            store.commit('doc/removeRoomDocFile', e.data)
        },
        room_doc_addPage: e => {
            store.commit('doc/addPage', e.data)
        },
        room_doc_addConvertPage: e => {
            store.commit('doc/addPage', e.data)
        },
        room_doc_changeRoomDocPage: e => {
            store.commit('doc/changeRoomDocFilePage', e.data)
        },
        room_doc_setDocId: e => {
            store.commit('doc/setRoomDocId', e.data)
        },
        room_doc_changeSharing: e => {
            store.commit('doc/changeSharing', e.data)
        },
        room_doc_setDocList: e => {
            const { roomDocList } = e.data
            store.commit('doc/addRoomDoc', roomDocList)
        }
    });
  }
}
